import { DATE_RELATIONS } from '@frontend/api';

export const UNIT_ONLY_DATE_RELATIONS = [DATE_RELATIONS.CURRENT] as const;
